module.exports = function () {
  var players = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var help = "Protestants select up to 2 uncommitted debaters. Papacy select up to 4 uncommitted debaters. Both sides roll dice equal to power. Hits on 5 or 6. Winner converts spaces equal to difference in hits.";
  var html = "\n      <div class=\"council-of-trent-overlay\" id=\"council-of-trent-overlay\">\n\t<div class=\"help\">".concat(help, "</div>\n\t<div class=\"debaters\"></div>\n      </div>\n  ");
  return html;
};